<template>
  <div class="landing-customer-comment-item rounded p-3">
    <div
      class="h-40 bg-white rounded-t-md p-4 relative flex items-center justify-center"
    >
      <p class="text-slate-500 text-xs text-center">
        {{ props.comment }}
      </p>
      <div class="absolute -bottom-6">
        <div
          class="size-14 bg-slate-100 rounded-full flex items-center justify-center"
        >
          <div
            class="bg-white size-12 rounded-full flex items-center justify-center"
          >
            <Icon name="ph:hand-heart-fill" class="text-orange-500 size-8" />
          </div>
        </div>
      </div>
    </div>
    <div
      class="h-20 bg-orange-500 flex flex-col items-center justify-end rounded-b-md p-2"
    >
      <span class="text-sm text-white"> {{ props.userName }} </span>
      <span class="font-sans text-xs text-white"> {{ props.userTitle }} </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    comment?: string
    userName?: string
    userTitle?: string
  }>(),
  {
    comment: '',
    userName: '',
    userTitle: '',
  },
)
</script>

<style scoped>
.landing-customer-comment-item {
  /* height: 368px;
  width: 454px; */
}
</style>
